module.exports = __webpack_public_path__ + "static/cpa_logo_practice3-ce6ddcbc2f7fe9a3bebb83e631174515.png";